export default {
  TITLE: 'A Partial List of Amazon Trademarks',
  CONTENT: `
  <p class="p-t-24">1-CLICK</p>
  <p>1-CLICK COMPARE</p>
  <p>1-CLICK WEBSTORE</p>
  <p>1800DIAPERS</p>
  <p>6PM</p>
  <p>6PM.COM IT'S TIME TO GET YOUR BRAND FIX Design</p>
  <p>43 PEOPLE</p>
  <p>43 PLACES</p>
  <p>43 THINGS</p>
  <p>47NORTH</p>
  <p>47 NORTH Design</p>
  <p>"a" Design</p>
  <p>A2Z</p>
  <p>A9</p>
  <p>A.COM</p>
  <p>A9.COM</p>
  <p>A9SEARCH</p>
  <p>A-ZSHOP</p>
  <p>A-LISTCOLLECTION</p>
  <p>ABE</p>
  <p>ABEBOOKS</p>
  <p>ACX AUDIOBOOK CREATION EXCHANGE and Design</p>
  <p>ADMASH</p>
  <p>ADVANCED BOOK EXCHANGE</p>
  <p>ADZINIA</p>
  <p>AIR PATRIOTS</p>
  <p>AIRPORT MANIA</p>
  <p>AJC COLLECTION</p>
  <p>AL DENTE</p>
  <p>ALEJANDRA SKY</p>
  <p>ALEXA</p>
  <p>ALL CONSUMING</p>
  <p>AMAZON</p>
  <p>AMAZON and Design</p>
  <p>AMAZON ANYWHERE</p>
  <p>AMAZONASSIST</p>
  <p>AMAZON BASICS Design</p>
  <p>AMAZON BOOKCLIPS PODCAST Design</p>
  <p>AMAZON.CA</p>
  <p>AMAZON.CA FIRST NOVEL AWARD WINNER Design</p>
  <p>AMAZON CLOUD DRIVE</p>
  <p>AMAZON CLOUD PLAYER</p>
  <p>AMAZON.COM</p>
  <p>AMAZON.COM Design</p>
  <p>AMAZON.COM ANYWHERE</p>
  <p>AMAZON.COM OUTLET</p>
  <p>AMAZONCONNECT</p>
  <p>AMAZONCROSSING</p>
  <p>AMAZON CURRENCY CONVERTER</p>
  <p>AMAZONDC</p>
  <p>AMAZON DEVPAY</p>
  <p>AMAZON EC2</p>
  <p>AMAZONENCORE</p>
  <p>AMAZON FLOW</p>
  <p>AMAZONFRESH</p>
  <p>AMAZON FRUSTRATION-FREE</p>
  <p>AMAZON GLACIER</p>
  <p>AMAZON HONOR SYSTEM</p>
  <p>AMAZONKINDLE</p>
  <p>AMAZON LINKS (Guitar Design)</p>
  <p>AMAZON MARKETPLACE</p>
  <p>AMAZON MECHANICAL TURK</p>
  <p>AMAZONMP3 Design</p>
  <p>AMAZON OUTLET</p>
  <p>AMAZON PAYMENTS</p>
  <p>AMAZON PERSONALIZATION NETWORK</p>
  <p>AMAZON PRIME</p>
  <p>AMAZON PRODUCT ADS</p>
  <p>AMAZON REMEMBERS</p>
  <p>AMAZON ROUTE 53</p>
  <p>AMAZON SERVICES JAPAN</p>
  <p>AMAZON SILK</p>
  <p>AMAZONSILK</p>
  <p>AMAZON SIMPLE PAY</p>
  <p>AMAZONSUPPLY</p>
  <p>AMAZONTOTE Design</p>
  <p>AMAZONUNBOX Design</p>
  <p>AMAZON VIDEO ON DEMAND Design</p>
  <p>AMAZON VINE</p>
  <p>AMAZON VPC</p>
  <p>AMAZON WEB SERVICES Design</p>
  <p>AMAZON WEBSTORE</p>
  <p>AMAZONWINDOWSHOP Design</p>
  <p>AMAZON WINE</p>
  <p>AMAZON WIRE PODCAST Design</p>
  <p>AMAZON{'@'}WORK</p>
  <p>AMI DANS LA RUE</p>
  <p>AMZN, AND YOU'RE DONE</p>
  <p>APPLY & BUY</p>
  <p>ARMCHAIR COMMENTARY</p>
  <p>ARTIFICIAL</p>
  <p>ASKVILLE</p>
  <p>ASSOCIATES CENTRAL</p>
  <p>ASTORE Design</p>
  <p>AUDIBLE</p>
  <p>AUDIBLEKIDS Design</p>
  <p>AUDIBLELISTENER</p>
  <p>AUDIBLEMANAGER</p>
  <p>AUDILBLEORIGINALS</p>
  <p>AUDIBLEREADY</p>
  <p>AUDIOBOOKSTAND</p>
  <p>AUDJIE</p>
  <p>AUTORIP</p>
  <p>AWS</p>
  <p>AWS MARKETPLACE Design</p>
  <p>BAG O'CRAP</p>
  <p>BEAUTY BAR</p>
  <p>BECAUSE YOU READ</p>
  <p>BETTERIZER</p>
  <p>BIBLIOFIND</p>
  <p>BID-CLICK</p>
  <p>BIOLABS</p>
  <p>BLACK ROOSTER</p>
  <p>BLOCKVIEW</p>
  <p>BOOKCASSETTE</p>
  <p>BOOK-OLOGY</p>
  <p>BOOKSLEUTH</p>
  <p>BOP</p>
  <p>BOP BASICS</p>
  <p>BOP BIJOUX</p>
  <p>BOTTOM OF THE PAGE</p>
  <p>BOUQUETS</p>
  <p>BOX OFFICE MOJO</p>
  <p>BRIGHTVOICE</p>
  <p>BRIGITTE BAILEY</p>
  <p>BRILLIANCE</p>
  <p>BRILLIANCE AUDIO</p>
  <p>BUY ONCE, READ EVERYWHERE</p>
  <p>BUYPHRASE</p>
  <p>CAMPERFORCE</p>
  <p>CERTIFIED FRUSTRATION-FREE PACKAGING</p>
  <p>CHECKOUT BY AMAZON</p>
  <p>CHORDSTRIKE</p>
  <p>CHRISTIN MICHAELS</p>
  <p>CLICKDRIVER</p>
  <p>CLICK.HEAR</p>
  <p>CLOUDFRONT</p>
  <p>CREATESPACE</p>
  <p>CRITICALMASS TICKETING</p>
  <p>CROSSLINKS</p>
  <p>CULTURE PHIT</p>
  <p>CUSTOMFLIX</p>
  <p>CVCORP</p>
  <p>DEALS.WOOT!</p>
  <p>DIAPERS.COM</p>
  <p>DENALI</p>
  <p>DON'T RESTRICT ME</p>
  <p>DPREVIEW</p>
  <p>DROP SHIP CENTRAL</p>
  <p>DYNAMODB</p>
  <p>EAMAZON</p>
  <p>EARTH'S BIGGEST</p>
  <p>EARTH'S BIGGEST BOOKSTORE</p>
  <p>EARTH'S BIGGEST MOVIE DATABASE</p>
  <p>EARTH'S BIGGEST SELECTION</p>
  <p>EC2</p>
  <p>EGGHEAD</p>
  <p>ELASTIC COMPUTE CLOUD</p>
  <p>ELASTICACHE</p>
  <p>EMERGENCY HOLIDAY PROVISIONS</p>
  <p>END USER</p>
  <p>ENDLESS</p>
  <p>FABRIC.COM</p>
  <p>FBA</p>
  <p>FILMFINDERS</p>
  <p>FIRE</p>
  <p>FITZWELL</p>
  <p>FULFILLMENT BY AMAZON</p>
  <p>GABCAB</p>
  <p>GABRIELLA ROCHA</p>
  <p>GAMECIRCLE</p>
  <p>GET ONLINE, NOT IN LINE</p>
  <p>GET STUFF. DONE.</p>
  <p>GETPHRASE</p>
  <p>GIFT CENTRAL</p>
  <p>GIFTPHRASE</p>
  <p>GLAMAZON FASHIONWEEK</p>
  <p>GOLD BOX</p>
  <p>GOOD AT FINDING GOODS</p>
  <p>GREEN 3</p>
  <p>GROWNUP SCHOOL</p>
  <p>HIGHBURY, HOLITUDE</p>
  <p>HOMEBASE</p>
  <p>I WANT ONE!</p>
  <p>IBERLIBRO</p>
  <p>IMDB</p>
  <p>IMPROVE YOUR HOLITUDE</p>
  <p>INNOVATIONS IN SEARCH TECHNOLOGIES</p>
  <p>IVONA</p>
  <p>JAVARI</p>
  <p>JOYO</p>
  <p>JOYO Design</p>
  <p>JUNGLEE Design</p>
  <p>JUNGLEE.COM</p>
  <p>JUSTBOOKS</p>
  <p>KIDS.WOOT!</p>
  <p>KINDLE</p>
  <p>KINDLE CERTIFIED EDUCATION SERVICE PROVIDER</p>
  <p>KINDLE CERTIFIED SERVICE PROVIDER</p>
  <p>KINDLE FIRE</p>
  <p>KINDLE FREETIME</p>
  <p>KINDLE POWERFAST</p>
  <p>KINDLE SINGLES</p>
  <p>LASSEN</p>
  <p>LE COMITE DES MAMANS</p>
  <p>LESS SCHLEP. MORE SHOP.</p>
  <p>LIGHTNING DEALS</p>
  <p>LISTMANIA</p>
  <p>LISTS OF BESTS</p>
  <p>LIVEBID</p>
  <p>LIVING CLASSICS</p>
  <p>LOOK INSIDE! Design</p>
  <p>LOVEFILM</p>
  <p>LOVEFILM INSTANT</p>
  <p>LUMIANI</p>
  <p>MADE FOR KINDLE Design</p>
  <p>MATCHES & MATRIMONY</p>
  <p>MECHANICAL TURK</p>
  <p>MERCHANTS{'@'}AMAZONCOM.JP</p>
  <p>MES Z'ENVIES CADEAUX</p>
  <p>MTURK</p>
  <p>MOBIPOCKET</p>
  <p>MONKEY PRIZE</p>
  <p>MOOFI</p>
  <p>MUSIC YOU SHOULD HEAR</p>
  <p>MYHABIT</p>
  <p>NEW FOR YOU</p>
  <p>NOT TOO COY</p>
  <p>NOVA AUDIO BOOKS</p>
  <p>NOWNOW</p>
  <p>OF NOTE</p>
  <p>OLE'ION</p>
  <p>OMAKASE</p>
  <p>OMNIVORACIOUS</p>
  <p>ONE COMMUNITY, EVERY DEAL</p>
  <p>ONE DAY, ONE DEAL</p>
  <p>ONE DAY, YOU'LL UNDERSTAND</p>
  <p>OPENSEARCH</p>
  <p>PAPERWHITE</p>
  <p>PASSION FOR BOOKS.</p>
  <p>PAYPHRASE</p>
  <p>PAY WITH AMAZON</p>
  <p>PIKE STREET</p>
  <p>PINZON</p>
  <p>POINTING DEVICES</p>
  <p>POLYPHEMUS!</p>
  <p>POWERED BY SERVICE</p>
  <p>PRE-DAWN DELIVERY</p>
  <p>PRIME</p>
  <p>PROMISCUOUS</p>
  <p>PURCHASE CIRCLES</p>
  <p>QUEST GOLD</p>
  <p>QUESTVILLE</p>
  <p>QUIDSI</p>
  <p>READERS</p>
  <p>REAL NAME</p>
  <p>REFLEXIVE</p>
  <p>REMOTELOAD</p>
  <p>RICOCHET</p>
  <p>ROMANTIC SOLES</p>
  <p>RSVP</p>
  <p>SEARCH INSIDE THE BOOK</p>
  <p>SEARCH INSIDE!</p>
  <p>SELLER CENTRAL</p>
  <p>SELLER DESKTOP</p>
  <p>SELL ON AMAZON</p>
  <p>SELLOUT.WOOT!</p>
  <p>SHARE THE LOVE</p>
  <p>SHELFARI</p>
  <p>SHIRT.WOOT!</p>
  <p>SHOPBOP</p>
  <p>SHOP WITH POINTS</p>
  <p>SHOULD DO THIS</p>
  <p>SILK</p>
  <p>SIMPLZ: ZOO</p>
  <p>SIT, WATCH, DISCUSS</p>
  <p>SKYSCAPE</p>
  <p>SMALLPARTS Design</p>
  <p>Smile Design</p>
  <p>SNAP TO LISTEN Design</p>
  <p>SNAPTELL</p>
  <p>SO YOU'D LIKE TO</p>
  <p>SOAP.COM</p>
  <p>SOULMATE</p>
  <p>SOUNDUNWOUND</p>
  <p>STANZA</p>
  <p>STARMETER</p>
  <p>STATE & LAKE</p>
  <p>STRATHWOOD</p>
  <p>SUBSCRIBE & SAVE Design</p>
  <p>TAKE-IT PRICE</p>
  <p>TEXTBUYME</p>
  <p>TEXTPAYME</p>
  <p>THE BOOK LIVES ON</p>
  <p>THE COOL PEOPLE</p>
  <p>THE LAST WORD ON KINDLE</p>
  <p>THE SIGNIFICANT SEVEN</p>
  <p>THING</p>
  <p>THOMAS & MERCER</p>
  <p>THOMAS & MERCER Design</p>
  <p>TOOL CRIB OF THE NORTH</p>
  <p>TOOTHSTEJNN</p>
  <p>TRIACIPEDIS</p>
  <p>TWO LIONS</p>
  <p>TYPE Z</p>
  <p>ULTIMATELISTENER</p>
  <p>UNBOX</p>
  <p>UNIVERSAL WISHLIST Design</p>
  <p>VENDOR CENTRAL</p>
  <p>VIGOTTI</p>
  <p>VIKTOR THE PREDIKTOR</p>
  <p>Vine Design</p>
  <p>VINE VOICE</p>
  <p>WAG REFLEX</p>
  <p>WAREHOUSE DEALS</p>
  <p>WE DELIVER EVERYTHING BUT THE BABY</p>
  <p>WHISPERCAST</p>
  <p>WHISPERLINK</p>
  <p>WHISPERNET</p>
  <p>WHISPERSHARE</p>
  <p>WHISPERSYNC</p>
  <p>WINTRY FLEECE</p>
  <p>WITHOUTABOX</p>
  <p>WOOT!</p>
  <p>WOOT CELLARS</p>
  <p>WOOT HAPPY HOUR</p>
  <p>WOOT-OFF!</p>
  <p>WRAP YOUR HOLIDAYS IN A SMILE</p>
  <p>X-RAY</p>
  <p>YOU SIT. WE FETCH.</p>
  <p>YOYO.COM</p>
  <p>ZAPPOS</p>
  <p>ZAPPOS.COM</p>
  <p>ZAPPOS COUTURE</p>
  <p>
 ZIRCONIUM and other Amazon.com graphics, logos, page headers, button
 icons, scripts, and service names are trademarks, registered trademarks or
 trade dress of Amazon in the United States and/or other countries.
 Amazon's trademarks and trade dress may not be used in connection with any
 product or service that is not Amazon's, in any manner that is likely to
 cause confusion among customers, or in any manner that disparages or
 discredits Amazon. All other trademarks not owned by Amazon that appear on
 this site are the property of their respective owners, who may or may not
 be affiliated with, connected to, or sponsored by Amazon.
</p>
  <p>Amazon amazon.cn & design</p>
<p>Amazon Web Services</p>
<p>Amazon</p>
<p>Amazon Elements</p>
<p>Amazon Basics</p>
<p>Excellence</p>
<p>Gold Reading Light</p>
<p>Gold Reading</p>
<p>Chawali</p>
<p>Minute by Minute</p>
<p>Wishlist</p>
<p>Express Step</p>
<p>Express Step Decathlon</p>
<p>Beautiful Express Step</p>
<p>Star Fight</p>
<p>Amazon & amazon.cn Z Affordable</p>
<p>Matching Street</p>
`
};
